import React, {Component} from 'react';
import {connect} from 'react-redux';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import * as A from '../store/lineageActions';

/**
 * Picks a DD object (table/view) for a given schemaId from /dataDictionary/objects/:schemaId.
 * onChange({objectId, objectName, objectType}) — exposes objectType so the view-expansion
 * follow-up (Req 14) can trigger expandViewLineage when objectType === 'VIEW'.
 */
class DdObjectPicker extends Component {
  componentDidMount() {
    if (this.props.schemaId) {
      this.props.fetchDdObjects(this.props.schemaId);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.schemaId && prevProps.schemaId !== this.props.schemaId) {
      this.props.fetchDdObjects(this.props.schemaId);
    }
  }

  render() {
    const {value, onChange, schemaId, ddObjects, label} = this.props;
    const pickerLabel = label || 'Table / View';
    const objects = (schemaId && ddObjects[schemaId]) || [];

    if (!schemaId) {
      return (
        <FormControl fullWidth disabled>
          <InputLabel>{pickerLabel}</InputLabel>
          <Select value=""><MenuItem value="">Select a schema first</MenuItem></Select>
        </FormControl>
      );
    }

    return (
      <FormControl fullWidth>
        <InputLabel>{pickerLabel}</InputLabel>
        <Select
          value={value || ''}
          onChange={(e) => {
            if (!onChange) return;
            const obj = objects.find((o) => (o.objectId || o.id) === e.target.value);
            if (obj) {
              onChange({
                objectId: obj.objectId || obj.id,
                objectName: obj.objectName || obj.tableName || obj.name || '',
                objectType: obj.objectType || obj.type || '',
              });
            } else {
              onChange({objectId: '', objectName: '', objectType: ''});
            }
          }}
          inputProps={{'data-testid': 'dd-object-picker-select'}}
        >
          <MenuItem value=""><em>None</em></MenuItem>
          {objects.map((o) => {
            const id = o.objectId || o.id;
            const name = o.objectName || o.tableName || o.name || id;
            const type = o.objectType || o.type || '';
            return (
              <MenuItem key={id} value={id}>
                {name}{type ? ` (${type})` : ''}
              </MenuItem>
            );
          })}
        </Select>
        {objects.length === 0 && <FormHelperText>No objects found for this schema</FormHelperText>}
      </FormControl>
    );
  }
}

const mapStateToProps = (state) => ({ddObjects: state.lineageReducer.ddObjects});

export default connect(mapStateToProps, {fetchDdObjects: A.fetchDdObjects})(DdObjectPicker);
